import type { IAuthRepository } from '../repositories/IAuthRepository.js';
import type { AuthSessionEntity } from '../entities/AuthSessionEntity.js';

interface Dependencies {
  authRepository: IAuthRepository;
}

export function createGetSessionUseCase({ authRepository }: Dependencies) {
  return async function getSession(): Promise<AuthSessionEntity | null> {
    return authRepository.getSession();
  };
}
